import React, { useState, useEffect } from 'react';
import { StyledModal } from '../../styleguide/styles/modals';
function CustomModal(props) {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    useEffect(function () {
        var _a;
        setIsOpen((_a = props.isOpen, (_a !== null && _a !== void 0 ? _a : false)));
    }, [props.isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledModal, { isOpen: isOpen }, props.content)));
}
export default CustomModal;
